import { render, staticRenderFns } from "./FollowUpSurvey.vue?vue&type=template&id=56936cff&scoped=true&"
import script from "./FollowUpSurvey.vue?vue&type=script&lang=js&"
export * from "./FollowUpSurvey.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpSurvey.vue?vue&type=style&index=0&id=56936cff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56936cff",
  null
  
)

export default component.exports